type dimension = {
  width: number;
  height: number;
};

export const DimensionOfImage = ({ width, height }: dimension) => {
  return `Image Dimensions: ${width}px × ${height}px`;
};
